var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0768 8.18182H7.61513V0.818182C7.61513 0.601187 7.70428 0.393079 7.86296 0.23964C8.02165 0.0862012 8.23688 0 8.4613 0H21.1538C21.3782 0 21.5935 0.0862012 21.7522 0.23964C21.9109 0.393079 22 0.601187 22 0.818182V17.1818C22 17.3988 21.9109 17.6069 21.7522 17.7604C21.5935 17.9138 21.3782 18 21.1538 18H8.4613C8.23688 18 8.02165 17.9138 7.86296 17.7604C7.70428 17.6069 7.61513 17.3988 7.61513 17.1818V9.81818H16.0768V8.18182ZM0.247641 8.42165L5.07662 3.75187L6.27342 4.90909L2.88875 8.18182H7.61513V9.81818H2.88875L6.27342 13.0909L5.07662 14.2481L0.247641 9.57835C0.0890732 9.42493 0 9.2169 0 9C0 8.7831 0.0890732 8.57507 0.247641 8.42165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.98e290b04cc534c5c86eee63303982ac.svg";
export { ForwardRef as ReactComponent };